/* ==========================================================================
   Provider User Guide Page
   Protected help guide for providers
   ========================================================================== */

import { PageContainer } from '@/components/layout/PageContainer'
import { ProviderPageHeader } from '@/components/layout/ProviderPageHeader'
import { ProviderTabBar } from '@/components/layout/ProviderTabBar'
import { GuideContent } from '@/components/guide/GuideContent'

export function UserGuide() {
  return (
    <PageContainer size="lg">
      <ProviderPageHeader />
      <ProviderTabBar />
      <GuideContent role="provider" />
    </PageContainer>
  )
}
